var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',{attrs:{"elevation":"2","loading":_vm.loading,"type":"table-thead, divider, table-tbody"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }